// import Vue from "vue"
// import util from '@/util'
// import firebase from "@/generic_api/firebase/firebase";
// import moment from '@/moment-gp.js';
import $models from '@/models'

export default {
    userData: ({ userData }) => {
      // TODO: REMOVE !!
      if ( $models.user.defaultUserId ) {
        // TODO: NOT REACTIVE
        return $models.userSettings.getNode( $models.user.defaultUserId )
      } else {
        throw new Error('userData called before user exist')
      }
    },

    userAuth: ({ userAuth }) => userAuth,

    loggedIn: ({ loggedIn }) => loggedIn,

    initialized: ({ initialized }) => initialized, // TODO: only used in resource loader

    // get_profile_pic: (state) => {
    //   /* TODO: analoge version für contact */
    //   /* TODO: return loading */
    //   /* TODO: return default from local / no svg */
    //
    //   if ( 'profilePic' in state.userData && state.userData.profilePic !== "" ) {
    //     return state.userData.profilePic;
    //   } else if ( 'picture' in state.userAuth && state.userAuth.picture !== "" &&
    //       state.userAuth.picture !== null ) {
    //     return state.userAuth.picture;
    //   } else {
    //     let filter = Vue.filter("defaultUserPic");
    //     return filter(null);
    //   }
    // },

    // userList: ({ userList }) => userList,
    // sidebarOpen: ({ sidebarOpen }) => sidebarOpen,

    // user_get_workspace_by_project_id: (state, getters, rootState, rootGetters) => ({ projectId }) => {
    //   console.warn("DEPRECATED");
    //     if (projectId === -1) return {};
    //     //let project = state.userData["projects[" + id + "]"];
    //
    //     /* WORKAROUND: This is a workaround to trick Vue's depedency tracker into
    //     updateting this function, whenver a new document is received. */
    //     // eslint-disable-next-line
    //     let dependencyFakeVariable = state.stateUpdateCounter * Math.random();
    //    /* console.log("+++1+++");
    //     console.log(getters.userData);
    //     console.log("+++2+++");
    //     console.log(getters.userData.projects);
    //     console.log("projectId:" + projectId);*/
    //     if (getters.userData.projects[projectId] && getters.userData.projects[projectId].workspace) {
    //       return getters.userData.projects[projectId].workspace;
    //     } else {
    //       return null;
    //     }
    // },

    /*
     Returns chat history with user
    */
    // chat_history_with_contact_id: (state) => contactId => {
    //   console.warn("DEPRECATED");
    //   let userData = state.userData;
    //   if ( 'private_chats' in userData &&
    //        contactId in userData.private_chats) {
    //     let history = userData.private_chats[contactId];
    //     let history_flat = Object.keys(history).map((idx) => {
    //       return { ...history[idx], ts: idx };
    //     })
    //     return history_flat.sort(util.sorter.by_ts);
    //   } else {
    //     return [];
    //   }
    // },

    /*
     Returns unread messages by user
    */
    // get_unread_messages_with_contact_id: (state) => contactId => {
    //   console.warn("DEPRECATED");
    //   let userData = state.userData;
    //   if ( 'private_chats' in userData &&
    //        contactId in userData.private_chats) {
    //     let history = userData.private_chats[contactId];
    //     let unread = Object.keys(history).filter( idx => {
    //       return history[idx].unread === true;
    //     });
    //     return unread.length;
    //   } else {
    //     return 0;
    //   }
    // },

    // user_get_language: (state) => {
    //   if (state.userData.settings &&
    //       state.userData.settings.language &&
    //       state.userData.settings.language !== "" ) {
    //     // TODO: check if language valid
    //     return state.userData.settings.language;
    //   }
    //   return null;
    // },

    // user_get_timezone: (state) => {
    //   if (state.userData.settings &&
    //       state.userData.settings.timezone &&
    //       state.userData.settings.timezone !== "" &&
    //       moment.tz.zone(state.userData.settings.timezone)) { // check if timezone valid
    //     return state.userData.settings.timezone;
    //   }
    //   // no valid timezone found, return nothing
    //   return 'I/DONT/KNOW' // TODO: null
    // },

    // user_get_dateformat: (state) => {
    //   if (state.userData.settings &&
    //       state.userData.settings.dateformat &&
    //       state.userData.settings.dateformat !== "" ) {
    //     return state.userData.settings.dateformat;
    //   }
    //   return 'LLLL';
    // },

    /*

    Now handles by enhanced moment

    user_get_UTCtimestamp: (state, getters) => {
      return moment().unix()
    },

    user_get_local_datetime: (state, getters) => (format) => {
      if (!format) {
        format = ''
      }
      return moment.tz(getters.user_get_timezone).format(format)
    },

    user_get_time_difference_browsertime_to_UTC_in_minutes: (state, getters) => {
      return moment().utcOffset()
    },

    user_get_time_difference_usertime_to_UTC_in_minutes: (state, getters) => {
      return moment.tz(getters.user_get_timezone).utcOffset()
    },

    user_get_UTC_time_for_local_time: (state, getters) => (momentObject) => {
      return momentObject.clone().subtract(getters.user_get_time_difference_usertime_to_UTC_in_minutes, 'minutes')
    },

    user_get_UTC_time : (state, getters) => (momentObject) => {
      return momentObject
    },

    user_get_UTC_time_for_browser_time : (state, getters) => (momentObject) => {
      return momentObject.clone().subtract(getters.user_get_time_difference_browsertime_to_UTC_in_minutes, 'minutes')
    }
    */
  }
